import { get, post } from '@/service/request';
import { requestOptions as options } from '@/service/requestOptions';

const url = 'api';
const eNotifyPath = `${url}/eNotifyPromo`;
// 0. 確認會員身份
export function postLoginNotify(data) {
    return post(`${url}/auth/eNotifyPromoLogin`, data, { ...options, closeAlert: true });
}

// 1. init初始化交易
export function postInitNotify() {
    return post(`${eNotifyPath}/initTransaction`);
}

// 2. 開始進行交易
export function postStartNotify(data) {
    return post(`${eNotifyPath}/startTransaction`, data);
}

// 3. 取得圖形驗證碼
export function postVerifyPngNotify() {
    return post(`${eNotifyPath}/produceVerifyCode`);
}

// 4. 會員驗證
export function postVerifySubmitNotify(data) {
    return post(`${eNotifyPath}/memberVerifySubmit`, data, { ...options, closeAlert: true });
}

export function postEncrypt(password) {
    return post(`${url}/auth/encrypt`, { plainText: window.btoa(password) });
}

// 5. 取得資料
export function getInfoNotify() {
    return get(`${eNotifyPath}/info`);
}

// 6. 電子通知單重要約定事項
export function getAgreeTermsNotify() {
    return get(`${eNotifyPath}/getAgreeTerms`);
}

// 7. 非會員/查詢會員-申請電子通知單同意事項-線上保單服務同意條款
export function getOnlineAgreeTermsNotify() {
    return get(`${eNotifyPath}/getOnlineAgreeTerms`);
}

// 8. 電子通知單重要約定事項同意
export function postAgreeNotify() {
    return post(`${eNotifyPath}/agree`);
}

// 9. 非會員/查詢會員/網投會員-線上保單服務同意條款同意
export function postOnlineAgreeNotify() {
    return post(`${eNotifyPath}/agreeOnlineAgreeTerms`);
}

// 10. 送出變更資料
export function postSubmitNotify(data) {
    return post(`${eNotifyPath}/submit`, data);
}

// 11. otp init
export function postOtpNotify(data) {
    return post(`${eNotifyPath}/initOtp`, data);
}

// 12. 選擇OTP發送的行動電話
export function postChooseOtp(data) {
    return post(`${eNotifyPath}/chooseOtp`, data);
}

// 12. 非會員-設定使用者代號密碼
export function postRegister(data) {
    return post(`${eNotifyPath}/register`, data);
}

// 13. 完成交易變更
export function postComplete() {
    return post(`${eNotifyPath}/complete`);
}
